var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { Transfer, ConfigProvider } from 'antd';
import { CustomTable } from './TableTransfer.style';
import enGB from 'antd/es/locale/en_GB';
import plPL from 'antd/es/locale/pl_PL';
export var TableTransfer = function (_a) {
    var columns = _a.columns, currentLanguage = _a.currentLanguage, restProps = __rest(_a, ["columns", "currentLanguage"]);
    return (React.createElement(Transfer, __assign({}, restProps, { showSelectAll: false, className: 'custom__transfer cyTableTransfer' }), function (_a) {
        var direction = _a.direction, filteredItems = _a.filteredItems, onItemSelectAll = _a.onItemSelectAll, onItemSelect = _a.onItemSelect, listSelectedKeys = _a.selectedKeys;
        var rowSelection = {
            getCheckboxProps: function (item) { return ({ disabled: item.disabled }); },
            onSelectAll: function (selected, selectedRows) {
                var treeSelectedKeys = selectedRows.filter(function (record) { return !record.disabled; }).map(function (record) { return record.key; });
                var diffKeys = selected
                    ? treeSelectedKeys.filter(function (record) { return !listSelectedKeys.includes(record.key); })
                    : listSelectedKeys.filter(function (key) { return !treeSelectedKeys.includes(key); });
                onItemSelectAll(diffKeys, selected);
            },
            onSelect: function (record, selected) {
                onItemSelect(record.key, selected);
            },
            selectedRowKeys: listSelectedKeys,
        };
        return (React.createElement(ConfigProvider, { locale: currentLanguage === 'en' ? enGB : plPL },
            React.createElement(CustomTable, { rowSelection: rowSelection, columns: columns, dataSource: filteredItems, size: 'small', pagination: false, className: direction === 'right' ? 'table__right' : '', rowClassName: function (record) { return (record.disabled ? 'table__row_disabled' : ''); }, onRow: function (record) { return ({
                    onClick: function () {
                        if (record.disabled)
                            return;
                        onItemSelect(record.key, !listSelectedKeys.includes(record.key));
                    },
                }); }, "data-cy": 'tableTransferData' })));
    }));
};
